exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video[data-v-2655ed0c]{width:100%;max-height:300px}", ""]);

// exports
